'use client';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { CatButton, CatIconClose } from 'components/blocks-components';
import styles from './smart-banner.module.scss';
import { useTranslations } from 'next-intl';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { isAndroidDevice } from '@cat-ecom/common/utils/browserUtils';
import {
  APP_BANNER_LOGO,
  ANDROID_APP_URI_SCHEME,
  ANDROID_INSTALL_URL,
  COOKIE_EXPIRATION_DAYS,
  SKIP_MOBILE_APP_ADVERT_BANNER_COOKIE
} from './constants';
import { MAIN_CAT_HEADER_ID_MOBILE } from '@cat-ecom/pcc-components/src/components/header/constants';
import { useEffect, useState } from 'react';
import { addDays } from 'date-fns';
import { setCookie, getCookie } from 'utils/cookieUtils';

export default function AppBanner({ isAndroidBannerActive, dealerName }) {
  const isMobile = !useBreakpoint(PAGE_BREAKPOINTS.MD);
  const t = useTranslations();
  const skipBanner = getCookie(SKIP_MOBILE_APP_ADVERT_BANNER_COOKIE);

  const [closeBanner, setCloseBanner] = useState(false);
  const showBanner =
    isMobile &&
    isAndroidDevice() &&
    isAndroidBannerActive &&
    !skipBanner &&
    !closeBanner;

  useEffect(() => {
    const bannerEl = document.getElementById('smart-banner-android');
    const bannerHeight = bannerEl?.getBoundingClientRect()?.height;
    const headerEl = document.getElementById(MAIN_CAT_HEADER_ID_MOBILE);
    if (headerEl)
      headerEl.style['top'] = showBanner ? `${bannerHeight}px` : '0';
  }, [showBanner]);

  if (!showBanner) {
    return null;
  }

  const handleOpen = () => {
    const currentUrl = window.location.href;
    const openUrl = ANDROID_APP_URI_SCHEME + currentUrl;
    window.location.href = openUrl;
    setTimeout(function () {
      const utm_campaign = `${dealerName}-app-download`;
      const clippedUTM = utm_campaign.substring(0, 30);
      const installURL = `${ANDROID_INSTALL_URL}${clippedUTM}&utm_term=install_now`;
      window.location.href = installURL;
    }, 25);
  };
  const handleClose = () => {
    const expiresDate = addDays(new Date(), COOKIE_EXPIRATION_DAYS);
    setCookie(SKIP_MOBILE_APP_ADVERT_BANNER_COOKIE, true, {
      expires: expiresDate
    });
    setCloseBanner(true);
  };

  return (
    <div
      id="smart-banner-android"
      className="d-blg-none bg-black d-flex align-items-center p-2 sticky-top"
    >
      <CatButton
        className="c-top-nav__menu-button"
        hideText={true}
        size="sm"
        inverted={true}
        data-testid="banner-close-button"
        onClick={() => handleClose()}
      >
        <CatIconClose slot="before" />
        {t('CLOSE')}
      </CatButton>
      <div className="px-2">
        <img
          src={APP_BANNER_LOGO}
          loading="lazy"
          alt="app-banner"
          className={styles['app-banner__logo-image']}
        />
      </div>

      <div className="d-flex flex-column">
        <span className={styles['app-banner__head-text']}>
          {t('RETAIL_MOBILE_APP_NAME')}
        </span>
        <span className={styles['app-banner__sub-text']}>
          {t('RETAIL_APP_SHORT_DESCRIPTION')}
        </span>
      </div>
      <div className="ms-auto">
        <CatButton
          variant="ghost"
          data-testid="banner-open-button"
          size="sm"
          onClick={() => {
            handleOpen();
          }}
        >
          <span className={styles['app-banner__open-button-text']}>
            {t('OPEN_BUTTON')}
          </span>
        </CatButton>
      </div>
    </div>
  );
}
